import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { ImgWrap } from 'pubBiz';

const SymmetricGrid = memo((props) => {
  const {
    width: cellWidth, // Any 容器宽度
    data, // Array 数据源
    multipleMargin, // Number 间隙数值
    onPress // Function 点击事件
  } = props;

  const renderItem = (item, index) => {
    const { imgInfo } = item;
    const { imgUrl, width, height } = imgInfo;
    const imgWidth = `calc((${cellWidth} - ${multipleMargin}) / 2)`;
    const imgHeight = `calc(((${cellWidth} - ${multipleMargin}) / 2) * ${height} / ${width})`;
    return (
      <Flex key={`SymmetricGrid${index}`} onClick={() => onPress && onPress(item)}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={imgWidth} h={imgHeight} />
      </Flex>
    );
  };

  return (
    <Flex direction="row" align="center" justify="between" style={{ width: '100%' }}>
      {data.map((item, index) => renderItem(item, index))}
    </Flex>
  );
});

// imgInfo成员结构
const imgInfoPropTypes = PropTypes.shape({
  imgUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
});

// data成员结构
const dataPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    imgInfo: imgInfoPropTypes.isRequired,
    id: PropTypes.string,
    type: PropTypes.string,
    content: PropTypes.string,
    extend: PropTypes.object
  })
);

SymmetricGrid.defaultProps = {
  data: [],
  multipleMargin: 0,
  onPress: null
};

SymmetricGrid.propTypes = {
  width: PropTypes.any.isRequired, // 容器宽度
  data: dataPropTypes, // 数据源
  multipleMargin: PropTypes.number, // 间隙数值
  onPress: PropTypes.func // 点击事件
};

export default SymmetricGrid;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/RecommandCell/components/SymmetricGrid/index.js